import { Modal } from "@asurion-core/aui-react-modal";
import { Action, Dropdown } from "@asurion-core/mx-asurion-ui-react";
import {
  setClockInModalOpen,
  setIsClockedIn,
  showToast,
  useGlobalDispatch,
  useTechnicianClockInMutation
} from "@ubif/util-store";
import { ChangeEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const StyledFooter = styled(Modal.Footer)`
  padding-top: 1.5rem;
  border-top: 1px solid #d5d6da;
`;

const StyledTitle = styled(Modal.Title)`
  font-weight: 700;
`;

const LOCATION_OPTIONS = [{ name: "In-Store", value: "IN_STORE" }];

export function ClockInLocationModal() {
  const { t } = useTranslation("root-config");
  const dispatch = useGlobalDispatch();
  const [location, setLocation] = useState<string>(LOCATION_OPTIONS[0].value); //TODO: get location from user's schedule
  const [clockIn, { isLoading }] = useTechnicianClockInMutation();

  const handleConfirm = async () => {
    try {
      await clockIn({ location }).unwrap();
      dispatch(setIsClockedIn(true));
      dispatch(setClockInModalOpen(false));
      setLocation(LOCATION_OPTIONS[0].value);
    } catch {
      dispatch(showToast({ toastType: "error", message: t("ClockInError"), time: 3000 }));
    }
  };

  const handleClose = () => {
    dispatch(setClockInModalOpen(false));
    setLocation(LOCATION_OPTIONS[0].value);
  };

  return (
    <Modal isOpen={true} isSticky={false} onCloseModal={handleClose}>
      <Modal.Header>
        <StyledTitle>{t("ClockIntoLocationTitle")}</StyledTitle>
      </Modal.Header>
      <Modal.Content>
        <Dropdown
          label={t("LocationToClockInto")}
          placeholder={t("PleaseChoose")}
          options={LOCATION_OPTIONS}
          value={location}
          onChange={(ev: ChangeEvent<HTMLSelectElement | HTMLInputElement>) => setLocation(ev.target.value)}
        />
      </Modal.Content>
      <StyledFooter>
        <Action disabled={!location || isLoading} state={isLoading ? "loading" : "enabled"} onClick={handleConfirm}>
          {t("Confirm")}
        </Action>
      </StyledFooter>
    </Modal>
  );
}
